/**
 * A PATH ON THE MACHINE, IN THE MACHINE'S OWN SEPARATOR — owner, 2026-10-27, over a Windows
 * machine's create sheet: windows 下的路徑 folder 的斜線方向跟 Linux / Mac 是相反的. The folder
 * field wrote `C:\Users\anrri/` and its picks `C:\Users\anrri/agents/`, and the agent was made
 * in that mixed spelling.
 *
 * The page does not know a machine's system; its paths say it. A path with a drive (`C:\`,
 * `C:/`) or a UNC share (`\\server\share`) is Windows's, and there `\` and `/` both separate and
 * `\` is written; anywhere else `/` alone separates — a backslash is a character a Unix file
 * name may hold.
 */
export function isWindowsPath(p: string): boolean {
  return /^[A-Za-z]:([\\/]|$)/.test(p) || p.startsWith('\\\\')
}

/** The separator to write in paths shaped like `p`. */
export function sepFor(p: string): '/' | '\\' {
  return isWindowsPath(p) ? '\\' : '/'
}

/** `p` without trailing separators — but a root stays a root (`/`, `C:\`). */
export function trimSep(p: string): string {
  if (isWindowsPath(p)) {
    const t = p.replace(/[\\/]+$/, '')
    return /^[A-Za-z]:$/.test(t) ? `${t}\\` : t
  }
  return p.replace(/\/+$/, '') || '/'
}

/** `base` and `name` joined with the machine's separator. */
export function joinPath(base: string, name: string): string {
  const b = trimSep(base)
  return /[\\/]$/.test(b) ? `${b}${name}` : `${b}${sepFor(base)}${name}`
}

/** Where the last separator in `text` is, or -1. */
export function lastSep(text: string): number {
  return isWindowsPath(text) ? Math.max(text.lastIndexOf('/'), text.lastIndexOf('\\')) : text.lastIndexOf('/')
}
